module.exports = __webpack_public_path__ + "files/ff982b62d4588432f197e665cf520a8f.svg";